import React, { useEffect, useState } from "react";

// Loacal imports
import PageLoader from "../global/page-loader";
import CTAStrip from "../global/cta.strip";
import { route } from "../global/route.global";
import Loader from "react-loader-spinner";
import CareerItem from "./career-item";

// Live imports
import { NavLink as Link, withRouter } from "react-router-dom";
import axios from "axios";
import Img from "../widgets/Img";
import moment from "moment";

function Career() {
  const [lists, setLists] = useState([]);
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
    getLists();
  }, []);

  const getLists = async () => {
    await axios
      .get(route.root.careers)
      .then(async (res) => {
        // console.log(res.data.data);
        setLists(res.data.data.careers);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
    setIsLoading(false);
  };

  return (
    <>
      <PageLoader />
      <div className="breadcrumb-wrapper">
        <div className="images-overlay"></div>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="page-heading">
                <h1>Careers</h1>
                <span className="line"></span>
              </div>
              <div className="page-breadcrumb-inner">
                <div className="page-breadcrumb">
                  <div className="breadcrumb-list">
                    <ul>
                      <li>
                        <Link to="/" activeclass="active">
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link to="/careers" activeclass="active">
                          Careers
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="blog-wrapper pt-5">
        <div className="container">
          <div className="row">
            {isLoading ? (
              <div className="container">
                <div className="text-center">
                  <Loader
                    type="TailSpin"
                    color="#f10d08"
                    height={70}
                    width={70}
                    timeout={9000}
                  />
                  <h6>LOADING...</h6>
                </div>
              </div>
            ) : null}

            <section className="inner-page-wrapper faq-wrapper">
              <div className="container">
                <div className="accordion" id="accordionExample">
                  {lists.map((i, k) => {
                    return <CareerItem item={i} key={k} />;
                  })}
                </div>
              </div>
            </section>
            {/* {lists.map((i, k) => {
              return (
                <div className="col-lg-12" key={k}>
                  <div className="item blog_card w-100">
                    <div className="post-detail display-flex">
                      <h5 title={i.job_title}>
                        <a href={`#`} tooltip={i.job_title}>
                          {i.job_title.length > 20
                            ? i.job_title.substring(0, 19) + "..."
                            : i.job_title}
                        </a>
                      </h5>
                      <div className="post-status">
                        <p>
                          <i className="fa fa-calendar"></i>
                          <span>
                            &nbsp;{moment(i.created_at).format("MMMM D, YYYY")}
                          </span>
                        </p>
                        <ul
                          style={{ height: "60px" }}
                          className="post-attachments"
                        >
                          {i.attachments.map((img, index) => {
                            return (
                              <li key={index}>
                                <span>
                                  <a
                                    href={`${route.domain}/storage/${img}`}
                                    target="_blank"
                                  >
                                    {img.endsWith(".pdf") ? (
                                      <i className="fa fa-file-pdf-o text-16"></i>
                                    ) : (
                                      <Img
                                        src={`${route.domain}/storage/${img}`}
                                        alt="img"
                                        with="30"
                                        height="30"
                                      />
                                    )}
                                  </a>
                                </span>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })} */}
            {/* 
            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img
                    src="/assets/uploads/careers/system-design-analyst.png"
                    alt=""
                  />
                </div>
                <div className="post-detail">
                  <h5>
                    <a
                      href="/assets/uploads/careers/system-design-analyst.pdf"
                      target="_blank"
                    >
                      System Design Analyst
                      <br /> <br />
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/blog/blog-title">Main Office</a>
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user"></i> <span>1 Personnel</span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/careers/system-design-analyst.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img src="/assets/uploads/careers/cwrc.png" alt="" />
                </div>
                <div className="post-detail">
                  <h5>
                    <a href="/assets/uploads/careers/cwrc.pdf" target="_blank">
                      Consumer Welfare and Relations Coordinator
                      <br /> <br />
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/blog/blog-title">Main Office</a>
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user"></i> <span>1 Personnel</span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/careers/cwrc.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img
                    src="/assets/uploads/careers/Line Technician (Area Maintenance).png"
                    alt=""
                  />
                </div>
                <div className="post-detail">
                  <h5>
                    <a
                      href="/assets/uploads/careers/Line Technician (Area Maintenance).pdf"
                      target="_blank"
                    >
                      Line Technician (Area Maintenance)
                      <br /> <br />
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/blog/blog-title">Main Office</a>
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user"></i> <span>1 Personnel</span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/careers/Line Technician (Area Maintenance).pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img
                    src="/assets/uploads/careers/Head, Line Technologist.png"
                    alt=""
                  />
                </div>
                <div className="post-detail">
                  <h5>
                    <a
                      href="/assets/uploads/careers/Head, Line Technologist.pdf"
                      target="_blank"
                    >
                      Head, Line Technologist
                      <br /> <br />
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/blog/blog-title">Main Office</a>
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user"></i> <span>1 Personnel</span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/careers/Head, Line Technologist.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img
                    src="/assets/uploads/careers/IT Specialist Programmer.png"
                    alt=""
                  />
                </div>
                <div className="post-detail">
                  <h5>
                    <a
                      href="/assets/uploads/careers/IT Specialist Programmer.pdf"
                      target="_blank"
                    >
                      IT Specialist/Programmer
                      <br /> <br />
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/blog/blog-title">Main Office</a>
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user"></i> <span>1 Personnel</span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/careers/IT Specialist Programmer.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img
                    src="/assets/uploads/careers/FINANCIAL AUDITOR1.png"
                    alt=""
                  />
                </div>
                <div className="post-detail">
                  <h5>
                    <a
                      href="/assets/uploads/careers/FINANCIAL AUDITOR.pdf"
                      target="_blank"
                    >
                      FINANCIAL AUDITOR
                      <br /> <br />
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/blog/blog-title">Main Office</a>
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user"></i> <span>1 Personnel</span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/careers/FINANCIAL AUDITOR.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img src="/assets/uploads/careers/HRDO-1.png" alt="" />
                </div>
                <div className="post-detail">
                  <h5>
                    <a href="/assets/uploads/careers/HRDO.pdf" target="_blank">
                      Human Resource Development Officer
                      <br /> <br />
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/blog/blog-title">Main Office</a>
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user"></i> <span>1 Personnel</span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/careers/HRDO.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img src="/assets/uploads/careers/CODO-1.png" alt="" />
                </div>
                <div className="post-detail">
                  <h5>
                    <a href="/assets/uploads/careers/CODO.pdf" target="_blank">
                      Consumer Organization and Development Officer
                      <br /> <br />
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/blog/blog-title">Main Office</a>
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user"></i> <span>1 Personnel</span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/careers/CODO.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img src="/assets/uploads/careers/AOE1.png" alt="" />
                </div>
                <div className="post-detail">
                  <h5>
                    <a href="/assets/uploads/careers/AOE.pdf" target="_blank">
                      Area Operations Engineer
                      <br /> <br />
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/blog/blog-title">Main Office</a>
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user"></i> <span>1 Personnel</span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/careers/AOE.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img src="/assets/uploads/careers/lt2.png" alt="" />
                </div>
                <div className="post-detail">
                  <h5>
                    <a href="/assets/uploads/careers/lt2.pdf" target="_blank">
                      Line Technician
                      <br /> <br />
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/blog/blog-title">Main Office</a>
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user"></i> <span>1 Personnel</span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/careers/lt2.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img src="/assets/uploads/careers/lt1.png" alt="" />
                </div>
                <div className="post-detail">
                  <h5>
                    <a href="/assets/uploads/careers/lt.pdf" target="_blank">
                      Line Technician
                      <br /> <br />
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/blog/blog-title">Main Office</a>
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user"></i> <span>1 Personnel</span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/careers/lt.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img src="/assets/uploads/careers/cac1.png" alt="" />
                </div>
                <div className="post-detail">
                  <h5>
                    <a
                      href="/assets/uploads/careers/consumer-account-coordinator.pdf"
                      target="_blank"
                    >
                      Consumer Account Coordinator <br /> <br />
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/blog/blog-title">Main Office</a>
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user"></i> <span>15 Personnel</span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/careers/consumer-account-coordinator.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img
                    src="/assets/uploads/careers/housewiring-inspector.png"
                    alt=""
                  />
                </div>
                <div className="post-detail">
                  <h5>
                    <a
                      href="/assets/uploads/careers/housewiring-inspector.pdf"
                      target="_blank"
                    >
                      Housewiring Inspector <br /> <br />
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/blog/blog-title">Main Office</a>
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user"></i> <span>1 Personnel</span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/careers/housewiring-inspector.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img src="/assets/uploads/careers/redo.png" alt="" />
                </div>
                <div className="post-detail">
                  <h5>
                    <a href="/assets/uploads/careers/redo.png" target="_blank">
                      Renewable Energy Development Officer
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/blog/blog-title">Main Office</a>
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user"></i> <span>1 Personnel</span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/careers/consumer-welfare-and-relations-coordinator.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img src="/assets/uploads/careers/reda.png" alt="" />
                </div>
                <div className="post-detail">
                  <h5>
                    <a href="/assets/uploads/careers/reda.png" target="_blank">
                      Renewable Energy Development Analyst
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/blog/blog-title">Main Office</a>
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user"></i> <span>1 Personnel</span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/careers/consumer-welfare-and-relations-coordinator.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img
                    src="/assets/uploads/careers/meter-technician.png"
                    alt=""
                  />
                </div>
                <div className="post-detail">
                  <h5>
                    <a
                      href="/assets/uploads/careers/meter-technician.png"
                      target="_blank"
                    >
                      Meter-Technician
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/blog/blog-title">Main Office</a>
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user"></i> <span>1 Personnel</span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/careers/meter-technician.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img src="/assets/uploads/careers/sst.png" alt="" />
                </div>
                <div className="post-detail">
                  <h5>
                    <a href="/assets/uploads/careers/sst.png" target="_blank">
                      Substation Tender
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/blog/blog-title">Main Office</a>
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user"></i> <span>3 Personnel</span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/careers/sst.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="item blog_card">
                <div className="post-img">
                  {" "}
                  <img
                    src="/assets/uploads/careers/heavy-eqpt-operator.png"
                    alt=""
                  />
                </div>
                <div className="post-detail">
                  <h5>
                    <a
                      href="/assets/uploads/careers/heavy-eqpt-operator.png"
                      target="_blank"
                    >
                      Heavy Equipment Operator
                    </a>
                  </h5>
                  <div className="post-status">
                    <ul>
                      <li>
                        <i className="fa fa-folder"></i>{" "}
                        <span>
                          <a href="/blog/blog-title">Main Office</a>
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user"></i> <span>2 Personnel</span>
                      </li>
                    </ul>
                  </div>
                  <div className="description">
                    <a
                      href="/assets/uploads/careers/heavy-eqpt-operator.pdf"
                      target="_blank"
                      className="theme-button-one bttn color-one"
                      data-text="Read more"
                    >
                      <span>Proceed</span>
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      <CTAStrip />
    </>
  );
}

export default withRouter(Career);
